import { useTranslation } from 'react-i18next'

import {
  Locales,
  localeToCountry,
  localeToCountryCode,
  localeToCountryUrlPrefix,
  localeToLanguage,
} from '@/utils/language'

export const useLocales = () => {
  const { i18n } = useTranslation()
  const locale = i18n.language as Locales

  return {
    locale,
    language: localeToLanguage(locale),
    country: localeToCountry(locale),
    countryPathnamePrefix: localeToCountryUrlPrefix(locale),
    countryCode: localeToCountryCode(locale),
    isLocale: {
      US: locale === Locales.EN_US,
      KR: locale === Locales.KO_KR,
      JP: locale === Locales.JA_JP,
      TH: locale === Locales.TH_TH,
      ZH_HANS: locale === Locales.ZH_HANS_CN,
      ZH_HANT: locale === Locales.ZH_HANT_TW,
    },
  }
}
